export const getAge = (date?: string): number | null => {
  if (!date) return null;

  const [month, day, year] = date.split('/').map(Number);
  if ([month, day, year].some(Number.isNaN)) return null;

  const today = new Date();

  const ageByYear = today.getFullYear() - year;
  const birthdayThisYear = new Date(today.getFullYear(), month - 1, day);

  return today >= birthdayThisYear ? ageByYear : ageByYear - 1;
};
